import { render, staticRenderFns } from "./BasePhotoEdit.vue?vue&type=template&id=ab88ff10&scoped=true"
import script from "./BasePhotoEdit.vue?vue&type=script&lang=js"
export * from "./BasePhotoEdit.vue?vue&type=script&lang=js"
import style0 from "./BasePhotoEdit.vue?vue&type=style&index=0&id=ab88ff10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab88ff10",
  null
  
)

export default component.exports